<div
  *ngIf="isCourseReserveWorkflowEnabled && showCourseReserveDates"
  class="text-end"
  i18n="@@courseReserveDates-label-courseReserveDates"
>
  On reserve from
  {{ item.content.start_date | amLocale : locale | amDateFormat : 'L' }} to
  {{ item.content.end_date | amLocale : locale | amDateFormat : 'L' }}
</div>
